import { graphql } from 'react-relay';

export const quoteBlockFragment = graphql`
    fragment QuoteBlock_contentBlock on QuoteBlock {
        text
        author
        iconUrl
    }
`;
